<template>
  <v-container class="py-10 py-md-13 py-lg-16 item">
    <TitleWidget>
      {{ item.title }}
    </TitleWidget>

    <v-row class="mt-6" justify="center" no-gutters>
      <v-col cols="12" md="9">
        <img
          v-if="image"
          @error="onError"
          class="d-block"
          loading="lazy"
          :src="image + '?resize=1&w=' + (xsOnly ? 600 : 1200)"
          :alt="item.title"
          width="100%"
        />

        <div
          v-if="item.text || item.introduction"
          class="
            grey--text
            text--darken-2 text-subtitle-1
            font-weight-light
            mt-6 mt-md-8
            item-text
            ck-content
          "
          v-html="item.text || item.introduction"
        ></div>

        <div v-if="images.length > 1" class="mt-10 mt-md-13">
          <TitleWidget align="left" small> Galeria </TitleWidget>

          <div class="mt-4 grid-list-images">
            <template v-for="(img, keyImages) in images">
              <img
                :key="keyImages"
                @click="showGallery(keyImages)"
                class="d-block cursor-pointer list-images-item"
                :src="img"
                width="100%"
              />
            </template>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TitleWidget from "../components/widgets/TitleWidget.vue";
import DefaultImg from "../assets/img/default-img.png";

const _config = {
  mod: "products",
};

export default {
  computed: {
    itemId() {
      return this.$route.params.item.replace(/^.*-([0-9]+)$/, "$1");
    },
    item() {
      return this.$rest(_config.mod).item;
    },
    image() {
      if (this.item?.img?.featured?.path)
        return this.files + this.item.img.featured.path;

      return "";
    },
    images() {
      if (!this.item?.img?.list?.length) return [];

      return this.item.img.list.map(({ path }) => {
        return this.files + path + "?resize=1&w=360";
      });
    },
    gallery() {
      if (!this.item?.img?.list?.length) return [];

      return this.item.img.list.map(({ path }) => ({
        src: this.files + path + "?resize=1&w=1600",
        thumbnail: this.files + path + "?resize=1&w=100",
      }));
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  methods: {
    showGallery(index) {
      window.showGalleryWidget(this.gallery, index);
    },
    onError(e) {
      e.target.src = DefaultImg;
    },
  },
  created() {
    this.$rest(_config.mod)
      .get({ id: this.itemId })
      .catch(() => this.$router.replace({ path: "/erro404" }));
  },
  components: {
    TitleWidget,
  },
};
</script>

<style lang="scss" scoped>
.item {
  &-text {
    line-height: 1.6;
  }

  &-video-content {
    aspect-ratio: 16 / 9;

    @media screen and (min-width: 960.001px) and (max-width: 1264px) {
      aspect-ratio: 1;
    }

    img,
    video {
      display: block;
      -o-object-fit: cover;
      object-fit: cover;
    }

    .item-video-mask {
      background-color: rgba(0, 0, 0, 0.5);
      bottom: 0;
      left: 0;
      position: absolute;
      right: 0;
      top: 0;
      transition: all 0.1s linear;

      &-icon {
        opacity: 0.9;
        transition: all 0.1s linear;
      }
    }

    &:hover {
      .item-video-mask {
        background-color: rgba(0, 0, 0, 0.2);

        &-icon {
          opacity: 1;
        }
      }
    }
  }
}

.grid-list-images {
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(4, 1fr);

  .list-images-item {
    aspect-ratio: 16 / 10;
    object-fit: cover;
  }
}
</style>
